import type { ReactNode } from "react";

export const btnShu =
  "press inline-flex items-center justify-center gap-2 border-2 border-ink bg-shu px-5 py-2.5 text-[14px] font-bold text-white hover:bg-shu-deep disabled:opacity-50";
export const btnInk =
  "press inline-flex items-center justify-center gap-2 border-2 border-ink bg-sheet px-5 py-2.5 text-[14px] font-bold text-ink hover:bg-marker disabled:opacity-40";

const STAMP_TONES = {
  shu: "border-shu text-shu",
  ink: "border-ink text-ink",
  solid: "border-shu bg-shu text-white",
};

export function Stamp({
  tone = "shu",
  tilt,
  children,
}: {
  tone?: keyof typeof STAMP_TONES;
  tilt?: boolean;
  children: ReactNode;
}) {
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1 border-2 px-1.5 py-px text-[11px] leading-tight font-black tracking-wider whitespace-nowrap ${STAMP_TONES[tone]} ${tilt ? "-rotate-3" : ""}`}
    >
      {children}
    </span>
  );
}

export function ChapterHead({
  no,
  kicker,
  title,
  id,
}: {
  no: string;
  kicker: string;
  title: ReactNode;
  id?: string;
}) {
  return (
    <header id={id} className="scroll-mt-20 border-b-4 border-double border-ink pb-2">
      <div className="flex items-center gap-2">
        <span className="bg-ink px-2 py-0.5 text-[12px] font-black tracking-widest text-paper">{no}</span>
        <span className="text-[12px] font-bold tracking-widest text-shu">{kicker}</span>
      </div>
      <h2 className="mt-2 text-[22px] leading-snug font-black tracking-tight sm:text-3xl">{title}</h2>
    </header>
  );
}

export function Check({ on }: { on: boolean }) {
  return (
    <span
      className={`inline-grid h-4 w-4 shrink-0 place-items-center border-2 border-ink text-[11px] leading-none font-black ${on ? "text-shu" : "text-transparent"}`}
      aria-hidden
    >
      ✓
    </span>
  );
}
